/* QNAP 自製 Bundle 配置器引擎
 * 無框架相依。可在佈景主題(Porto)與獨立 demo 頁共用。
 *
 * 核心觀念:bundle 本質是「快速挑幾個單品、以各自的 Shopify 原價加入購物車」。
 *   - 不改變 Shopify 規則、無 app、無 Plus、無 Cart Transform、無 Function。
 *   - 「折扣/省」= 各單品自身的特價(compare_at_price),前端向 Shopify 現查,不是 bundle 層級。
 *   - 加入購物車 = 各選中單品以獨立行進車,帶 _qnap_bundle_* 屬性供「購物車主題層視覺分組」。
 *
 * 掛載:QNAPBundle.mount(rootEl, { config, dataMap, onAddToCart })
 *   - config  : 符合 bundle-config.schema 的物件(選項以 handle 為主鍵)
 *   - dataMap : { <handle>: { variantId:<int>, price:<現價TWD>, compareAt:<原價TWD|null>, image:<url> } }
 *               由佈景主題 Liquid 以 all_products[handle] 現查注入;價格/變體/圖片皆以 Shopify 為準。
 *   - onAddToCart(items, root) : 選填;省略時走 Shopify /cart/add.js
 * 若省略參數,會自動讀取 root 內的 <script data-qb-config> / <script data-qb-data>。
 */
(function (global) {
  "use strict";

  var uidSeq = 0;
  function uid() { uidSeq += 1; return "qb" + Date.now().toString(36) + "-" + uidSeq; }

  function money(n) {
    n = Math.round(Number(n) || 0);
    return "NT$" + n.toLocaleString("en-US");
  }

  // 群組語意輔助
  function isSingle(g) { return (g.selectMode || "single") !== "multi"; }
  function groupCap(g) { return (g.maxTotal == null) ? Infinity : Number(g.maxTotal); }
  function minReq(g) { return g.required ? 1 : 0; }

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { console.warn("[QNAPBundle] JSON parse fail", sel, e); return null; }
  }

  function Configurator(root, opts) {
    this.root = root;
    this.config = opts.config || readJSON(root, "[data-qb-config]");
    this.data = opts.dataMap || readJSON(root, "[data-qb-data]") || {};
    this.onAddToCart = opts.onAddToCart || null;
    this.state = {}; // { groupId: { optionId: qty } }
    if (!this.config) { root.innerHTML = '<p class="qb-note">找不到 bundle 設定。</p>'; return; }
    // 顯示標題:config.title(選填覆寫) → 承載商品標題(data-qb-title) → 空
    this.title = this.config.title || root.getAttribute("data-qb-title") || "";
    this.initState();
    this.render();
  }

  Configurator.prototype.entry = function (opt) { return this.data[opt.handle] || {}; };
  Configurator.prototype.price = function (opt) { var p = this.entry(opt).price; return p == null ? 0 : Number(p); };
  // 原價(compare_at);無特價時回傳 0
  Configurator.prototype.compareAt = function (opt) { var c = this.entry(opt).compareAt; return c == null ? 0 : Number(c); };
  Configurator.prototype.variantId = function (opt) { return opt.variantId || this.entry(opt).variantId || null; };
  // 庫存上限:available=false → 0;stock 未提供(未追蹤或缺貨可續賣) → 無上限
  Configurator.prototype.stockCap = function (opt) {
    var e = this.entry(opt);
    if (e.available === false) return 0;
    return (e.stock == null) ? Infinity : Math.max(0, Number(e.stock));
  };

  Configurator.prototype.initState = function () {
    var self = this;
    (this.config.groups || []).forEach(function (g) {
      self.state[g.groupId] = {};
      var defs = (g.options || []).filter(function (o) { return o.isDefault && self.stockCap(o) > 0; });
      if (!defs.length) return;
      if (isSingle(g)) self.state[g.groupId][defs[0].optionId] = 1;
      else { var cap = groupCap(g), n = 0; defs.forEach(function (o) { if (n < cap) { self.state[g.groupId][o.optionId] = 1; n++; } }); }
    });
  };

  Configurator.prototype.groupCount = function (g) {
    var m = this.state[g.groupId] || {}, sum = 0;
    Object.keys(m).forEach(function (k) { sum += m[k]; });
    return sum;
  };

  Configurator.prototype.groupComplete = function (g) {
    if (!g.required) return true;
    return this.groupCount(g) >= minReq(g);
  };

  Configurator.prototype.advanceFrom = function (groupId) {
    var groups = this.config.groups || [];
    var idx = groups.findIndex(function (g) { return g.groupId === groupId; });
    for (var i = idx + 1; i < groups.length; i++) {
      if (!this.groupComplete(groups[i])) { this._scrollTo = groups[i].groupId; return; }
    }
    this._scrollTo = "__summary";
  };

  Configurator.prototype.selectSingle = function (g, opt) {
    if (this.stockCap(opt) <= 0) return; // 缺貨品項不可選
    this.state[g.groupId] = {};
    this.state[g.groupId][opt.optionId] = 1;
    this.advanceFrom(g.groupId);
    this.render();
  };

  Configurator.prototype.changeQty = function (g, opt, delta) {
    var m = this.state[g.groupId] || (this.state[g.groupId] = {});
    var cur = m[opt.optionId] || 0;
    var next = cur + delta;
    if (next < 0) next = 0;
    var cap = groupCap(g);
    var others = this.groupCount(g) - cur;
    if (delta > 0 && others + next > cap) return; // 擋住超過群組總量上限
    if (delta > 0 && next > this.stockCap(opt)) return; // 擋住超過庫存
    if (next === 0) delete m[opt.optionId]; else m[opt.optionId] = next;
    if (delta > 0 && cap !== Infinity && this.groupCount(g) >= cap) this.advanceFrom(g.groupId);
    this.render();
  };

  // 合計:現價總(實收) + 原價總 → 省額 = 各單品自身特價加總
  Configurator.prototype.totals = function () {
    var self = this, now = 0, was = 0;
    (this.config.groups || []).forEach(function (g) {
      var m = self.state[g.groupId] || {};
      g.options.forEach(function (o) {
        var q = m[o.optionId] || 0;
        if (!q) return;
        var p = self.price(o), c = self.compareAt(o);
        now += p * q;
        was += (c > p ? c : p) * q;
      });
    });
    return { base: was, discount: was - now, final: now };
  };

  Configurator.prototype.validate = function () {
    var self = this, errs = [];
    (this.config.groups || []).forEach(function (g) {
      if (g.required && self.groupCount(g) < minReq(g)) {
        var anyStock = (g.options || []).some(function (o) { return self.stockCap(o) > 0; });
        if (anyStock) errs.push("「" + g.label + "」為必選,請至少選 1 件");
        else errs.push("「" + g.label + "」品項目前缺貨,此組合暫時無法購買");
      }
    });
    return errs;
  };

  Configurator.prototype.render = function () {
    var self = this, c = this.config;
    var wrap = document.createElement("div");

    var head = '<div class="qb__head"><h2 class="qb__title">' + esc(this.title) + '</h2>' +
      (c.subtitle ? '<p class="qb__sub">' + esc(c.subtitle) + '</p>' : '') + '</div>';

    var groupsHtml = (c.groups || []).map(function (g, gi) {
      var single = isSingle(g);
      var cap = groupCap(g);
      var m = self.state[g.groupId] || {};
      var full = !single && cap !== Infinity && self.groupCount(g) >= cap;
      var opts = g.options.map(function (o) {
        var p = self.price(o);
        var was = self.compareAt(o);
        var onSale = was > p;
        var q = m[o.optionId] || 0;
        var selected = q > 0;
        var img = o.image || self.entry(o).image || "";
        var scap = self.stockCap(o);
        var soldOut = scap <= 0;
        var priceHtml = g.hidePrice ? '' : (onSale
          ? '<span class="qb-was">' + money(was) + '</span><span class="qb-now">' + money(p) + '</span>'
          : '<span class="qb-now">' + money(p) + '</span>');
        var saveHtml = (!g.hidePrice && onSale) ? '<div class="qb-opt__save">省 ' + money(was - p) + '</div>' : '';
        var stockHtml = '';
        if (soldOut) stockHtml = '<div class="qb-opt__stock qb-opt__stock--out">目前缺貨</div>';
        else if (scap !== Infinity && (q >= scap || scap <= 3)) stockHtml = '<div class="qb-opt__stock">庫存僅 ' + scap + ' 件</div>';
        var qtyHtml = (single || soldOut) ? '' :
          '<div class="qb-qty" data-qty>' +
            '<button type="button" data-act="dec" ' + (q <= 0 ? "disabled" : "") + '>－</button>' +
            '<span class="qb-qty__n">' + q + '</span>' +
            '<button type="button" data-act="inc" ' + (((full && q <= 0) || q >= scap) ? "disabled" : "") + '>＋</button>' +
          '</div>';
        return '<div class="qb-opt' + (selected ? ' is-selected' : '') + (soldOut ? ' qb-opt--soldout' : '') + '" data-g="' + gi + '" data-o="' + esc(o.optionId) + '" role="button" tabindex="' + (soldOut ? '-1' : '0') + '"' + (soldOut ? ' aria-disabled="true"' : '') + '>' +
          (img ? '<img class="qb-opt__img" src="' + esc(img) + '" alt="' + esc(o.title || "") + '" loading="lazy">' : '') +
          '<div class="qb-opt__title">' + esc(o.title || o.optionId) + '</div>' +
          (priceHtml ? '<div class="qb-opt__price">' + priceHtml + '</div>' : '') +
          saveHtml + stockHtml + qtyHtml +
        '</div>';
      }).join("");

      var reqTag = g.required ? '必選' : '選配';
      var count = self.groupCount(g);
      var maxTag = (!single && cap !== Infinity) ? ' · 最多 ' + cap + ' 件' : '';
      var remainHtml = '';
      if (!single && cap !== Infinity) {
        var remain = cap - count;
        remainHtml = (remain > 0)
          ? '<span class="qb-group__remain">還可選 ' + remain + ' 件</span>'
          : '<span class="qb-group__remain is-full">已達上限（' + cap + ' 件）</span>';
      }
      var done = self.groupComplete(g) && count > 0;
      return '<section class="qb-group' + (done ? ' is-complete' : '') + '" data-group="' + esc(g.groupId) + '">' +
        '<div class="qb-group__head"><span class="qb-group__step">' + (done ? '✓' : (gi + 1)) + '</span>' +
          '<div><h3 class="qb-group__label">' + esc(g.label) +
          ' <span class="qb-group__req">(' + reqTag + maxTag + ')</span></h3>' +
          (g.helpText ? '<p class="qb-group__help">' + esc(g.helpText) + '</p>' : '') + remainHtml + '</div></div>' +
        '<div class="qb-opts">' + opts + '</div></section>';
    }).join("");

    var t = this.totals();
    var errs = this.validate();
    var savingHtml = t.discount > 0
      ? '<span class="qb-was">' + money(t.base) + '</span><span class="qb-save">省 ' + money(t.discount) + '</span>'
      : '';
    var summary = '<div class="qb-summary" data-qb-summary>' +
      '<div class="qb-summary__prices">' +
        '<div class="qb-summary__total">' + money(t.final) + '</div>' +
        '<div class="qb-summary__meta">' + savingHtml + '</div>' +
      '</div>' +
      '<button type="button" class="qb-atc">加入購物車</button>' +
    '</div>' +
    (errs.length ? '<p class="qb-note">' + esc(errs.join("；")) + '</p>' : '');

    wrap.innerHTML = head + groupsHtml + summary;
    this.root.innerHTML = "";
    this.root.appendChild(wrap);
    this.bind();
    this.doScroll();
  };

  Configurator.prototype.doScroll = function () {
    var target = this._scrollTo;
    this._scrollTo = null;
    if (!target) return;
    var el = target === "__summary"
      ? this.root.querySelector("[data-qb-summary]")
      : this.root.querySelector('[data-group="' + target + '"]');
    if (!el) return;
    requestAnimationFrame(function () {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = r.top >= 0 && r.top < vh * 0.5;
      if (!visible) {
        var y = window.pageYOffset + r.top - (target === "__summary" ? vh * 0.4 : 80);
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      if (target !== "__summary") {
        el.classList.add("qb-group--focus");
        setTimeout(function () { el.classList.remove("qb-group--focus"); }, 1200);
      }
    });
  };

  Configurator.prototype.bind = function () {
    var self = this, c = this.config;
    this.root.querySelectorAll(".qb-opt").forEach(function (card) {
      var gi = +card.getAttribute("data-g");
      var g = c.groups[gi];
      var opt = g.options.find(function (o) { return o.optionId === card.getAttribute("data-o"); });
      if (self.stockCap(opt) <= 0) return; // 缺貨卡片不綁互動
      if (isSingle(g)) {
        var act = function () { self.selectSingle(g, opt); };
        card.addEventListener("click", act);
        card.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); act(); } });
      } else {
        // 點卡片本體 = 第一次選取(數量 0→1);已選取後的增減仍走 ＋/－ 按鈕。
        var firstPick = function () { if (((self.state[g.groupId] || {})[opt.optionId] || 0) === 0) self.changeQty(g, opt, 1); };
        card.addEventListener("click", firstPick);
        card.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); firstPick(); } });
        card.querySelectorAll("[data-act]").forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.stopPropagation();
            self.changeQty(g, opt, btn.getAttribute("data-act") === "inc" ? 1 : -1);
          });
        });
      }
    });
    var atc = this.root.querySelector(".qb-atc");
    if (atc) atc.addEventListener("click", function () { self.addToCart(); });
  };

  // 各選中單品以獨立行加入,帶 _qnap_bundle_* 屬性供購物車主題層視覺分組(無父行、無合併)
  Configurator.prototype.buildItems = function () {
    var self = this, c = this.config, items = [], groupUid = uid();
    var baseProps = { _qnap_bundle_uid: groupUid };
    if (this.title) baseProps._qnap_bundle_title = this.title;
    baseProps._qnap_bundle_url = window.location.pathname;
    (c.groups || []).forEach(function (g) {
      var m = self.state[g.groupId] || {};
      g.options.forEach(function (o) {
        var q = m[o.optionId] || 0;
        if (!q) return;
        var vid = self.variantId(o);
        if (!vid) { console.warn("[QNAPBundle] 找不到 variantId for handle:", o.handle); return; }
        items.push({
          id: vid,
          quantity: q,
          properties: Object.assign({}, baseProps, { _qnap_bundle_group: g.groupId })
        });
      });
    });
    // 標記群組1的第一個選中品項為「封面」：購物車/迷你車組合卡以它的圖代表整組。
    // （Shopify 可能倒置購物車行順序，故用明確標記而非「第一行」。）
    if (items.length) items[0].properties._qnap_bundle_cover = "1";
    return items;
  };

  // 必選群組未選時：捲動並閃紅提示第一個未完成群組（點 2）
  Configurator.prototype.flagIncomplete = function () {
    var self = this, groups = this.config.groups || [];
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (g.required && self.groupCount(g) < minReq(g)) {
        var el = self.root.querySelector('[data-group="' + g.groupId + '"]');
        if (el) {
          el.classList.add('qb-group--error');
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { el.classList.remove('qb-group--error'); }, 2000);
        }
        return;
      }
    }
  };

  Configurator.prototype.addToCart = function () {
    var errs = this.validate();
    if (errs.length) { this.flagIncomplete(); return; }
    var items = this.buildItems();
    if (this.onAddToCart) { this.onAddToCart(items, this.root); return; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || "stock"); });
        return r.json();
      })
      .then(function () { if (!window.__qbHasAtcModal) window.location.href = "/cart"; })
      .catch(function (e) {
        console.error("[QNAPBundle] add to cart fail", e);
        var msg = (e && e.message && e.message !== "stock")
          ? "加入購物車失敗：" + e.message
          : "加入購物車失敗，可能是庫存不足，請調整數量後再試。";
        alert(msg);
      });
  };

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  var QNAPBundle = {
    mount: function (root, opts) { return new Configurator(root, opts || {}); },
    autoInit: function () {
      document.querySelectorAll(".qb[data-qnap-bundle]").forEach(function (root) {
        if (root.__qbMounted) return;
        root.__qbMounted = true;
        QNAPBundle.mount(root, {});
      });
    },
    _money: money
  };

  global.QNAPBundle = QNAPBundle;
  if (document.readyState !== "loading") QNAPBundle.autoInit();
  else document.addEventListener("DOMContentLoaded", QNAPBundle.autoInit);
})(window);
